import React from "react";
import { Routes, Route } from "react-router-dom";

import EmptyLayout from "../component/EmptyLayout";
import LoginPage from '../component/dump/forms/login/LoginPage';
import RestorePasswordPage from "../component/dump/forms/login/RestorePasswordPage";
import ResetPasswordPage from "../component/dump/forms/login/ResetPasswordPage";
import CreatePasswordPage from "../component/dump/forms/login/CreatePasswordPage";
import NotFoundComponent from "../component/dump/NotFoundComponent";
import GeotabCredentialsContainer from "../component/smart/geotab/GeotabCredentialsContainer";
import WebfleetCredentialsContainer from "../component/smart/geotab/WebfleetCredentialsContainer";
import IturanCredentialsContainer from "../component/smart/geotab/IturanCredentialsContainer";
import ConfirmationPage from "../component/dump/forms/login/ConfirmationPage";
import PatternsPartnerRedirectContainer from "../component/smart/patterns/PatternsPartnerRedirectContainer";

import LiveVideoLayout from '../component/LiveVideoLayout';
import RequireWebfleetAuth from "./auth/RequireWebfleetAuth";
import RequireAuth from "./auth/RequireAuth";
import EulaAgreementPage from "../component/smart/forms/login/EulaAgreementPage";
import LiveVideoContainer from "../component/smart/menuComponentsContainer/LiveVideoContainer";
import LiveVideoErrorContainer from "../component/smart/menuComponentsContainer/LiveVideoErrorContainer";
import AdvancedPlayerOpenClip from "../component/smart/permalinks/AdvancedPlayerOpenClip";

import Layout from "../component/Layout";
import HomeAccess from "../component/smart/menuComponentsContainer/HomeAccess";
import SupportContainer from "../component/smart/menuComponentsContainer/SupportContainer";
import LegalNotice from "../component/dump/menuComponents/LegalNotice";
import ManageVehicles from "../component/smart/menuComponentsContainer/ManageVehicles";
import EditAssetContainer from "../component/smart/menuComponentsContainer/EditAssetContainer";
import InstallationReportAssetContainer
    from "../component/smart/menuComponentsContainer/InstallationReportAssetContainer";
import ZonesPage from "../pages/zones";
import ManageAssetsGroups from "../component/dump/menuComponents/ManageAssetsGroups";
import AddGroupContainer from "../component/smart/menuComponentsContainer/AddGroupContainer";
import EditGroupContainer from "../component/smart/menuComponentsContainer/EditGroupContainer";
import ManageUsers from "../component/dump/menuComponents/ManageUsers";
import ManageAssetsUserEditContainer from "../component/smart/menuComponentsContainer/ManageAssetsUserEditContainer";
import AccountSettings from "../component/smart/account/AccountSettings";
import RequireRole from "./auth/RequireRole";
import FleetAdminServerStatsContainer from "../component/smart/menuComponentsContainer/FleetAdminServerStatsContainer";
import AdminSingleActions from "../component/smart/menuComponentsContainer/AdminSingleActions";
import ReleasesPage from "../pages/releases/ReleasesPage";
import ChangePasswordContainer from "../component/smart/menuComponentsContainer/ChangePasswordContainer";
import FleetAdminModemContainer from "../pages/modems/FleetAdminModemContainer";
import AccountFleetSettings from "../component/smart/account/AccountFleetSettings";
import PartnerWhitelabelSettings from "../pages/partners/whitelabel/PartnerWhitelabelSettings";
import CompanyContainer from "../component/smart/menuComponentsContainer/CompanyContainer";
import CompanyEditContainerTabs from "../pages/companies/CompanyEditContainerTabs";
import PartnerContainer from "../component/smart/menuComponentsContainer/PartnerContainer";
import PartnerEditContainer from "../component/smart/menuComponentsContainer/PartnerEditContainer";
import PartnerAddContainer from "../component/smart/menuComponentsContainer/PartnerAddContainer";
import Events from "../component/dump/menuComponents/Events";
import AccountUserContainer from "../component/smart/account/AccountUserContainer";
import Reports from "../component/dump/menuComponents/Reports";
import Firmware from "../pages/firmware/Firmware";
import ManageDriversPage from "../pages/drivers/ManageDriversPage";
import PatternsEventContainer from "../component/smart/patterns/PatternsEventContainer";
import PatternsEventIdContainer from "../component/smart/patterns/PatternsEventIdContainer";
import PatternsDriverIdContainer from "../component/smart/patterns/PatternsDriverIdContainer";
import PatternsDeviceInstalledReport from "../component/smart/patterns/PatternsDeviceInstalledReport";
import PatternsDeviceContainer from "../component/smart/patterns/PatternsDeviceContainer";

const AppRoutes = () => {
    return (
        <Routes>
            <Route element={<EmptyLayout />}>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/restore-password" element={<RestorePasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/create-password" element={<CreatePasswordPage />} />
                <Route path="/not-found" element={<NotFoundComponent />} />
                <Route path="/mygeotab/credentials/:provider/:companyHash" element={<GeotabCredentialsContainer />} />
                <Route path="/webfleet/credentials/:companyHash" element={<WebfleetCredentialsContainer />} />
                <Route path="/ituran/credentials/:companyHash" element={<IturanCredentialsContainer />} />
                <Route path="/confirmation" element={<ConfirmationPage />} />
                <Route path="/permalink/partner/:page_type/:company_id" element={<PatternsPartnerRedirectContainer />} />
                <Route path="/permalink/partner/:page_type/:company_id/:id" element={<PatternsPartnerRedirectContainer />} />
            </Route>
            <Route element={<RequireWebfleetAuth />}>
                <Route element={<LiveVideoLayout />}>
                    <Route path="/live/stream/:deviceId" element={<LiveVideoContainer />} />
                    <Route path="/live/stream/:deviceId/error" element={<LiveVideoErrorContainer />} />
                </Route>
            </Route>
            <Route element={<RequireAuth />}>
                <Route element={<LiveVideoLayout />}>
                    <Route path="/live/video/:deviceId" element={<LiveVideoContainer />} />
                    <Route path="/live/video/:deviceId/error" element={<LiveVideoErrorContainer />} />
                </Route>
            </Route>
            <Route element={<RequireAuth />}>
                <Route path="/event/video/:eventId" element={<AdvancedPlayerOpenClip />} />
            </Route>
            <Route element={<RequireAuth />}>
                <Route element={<LiveVideoLayout />}>
                    <Route path="/eula-agreement" element={<EulaAgreementPage />} />
                </Route>
                <Route path="/" element={<Layout />}>
                    <Route index element={<HomeAccess />} />
                    <Route path="support" element={<SupportContainer />} />
                    <Route path="legal-notice" element={<LegalNotice />} />
                    <Route path="managevehicles" element={<ManageVehicles />} />
                    <Route path="managevehicles/edit" element={<EditAssetContainer />} />
                    <Route path="managevehicles/edit/:id" element={<EditAssetContainer />} />
                    <Route path="managevehicles/installation/report" element={<InstallationReportAssetContainer />} />
                    <Route path="zones" element={<ZonesPage />} />
                    <Route path="managegroups" element={<ManageAssetsGroups />} />
                    <Route path="managegroups/add" element={<AddGroupContainer />} />
                    <Route path="managegroups/edit" element={<EditGroupContainer />} />
                    <Route path="manageusers" element={<ManageUsers />} />
                    <Route path="manageusers/edit" element={<ManageAssetsUserEditContainer />} />
                    <Route path="/account/settings" element={<AccountSettings />} />
                    <Route element={<RequireRole roles={['system_admin']} />}>
                        <Route path="/fleet-admin/server-stats" element={<FleetAdminServerStatsContainer />} />
                        <Route path="/single-actions" element={<AdminSingleActions />} />
                        <Route path="/fleet-admin/releases" element={<ReleasesPage />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'partner']} />}>
                        <Route path="manageusers/change-password" element={<ChangePasswordContainer />} />
                        <Route path="/fleet-admin/modem" element={<FleetAdminModemContainer />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'partner', 'fleet_manager']} />}>
                        <Route path="/account/fleet-settings" element={<AccountFleetSettings />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin']} />}>
                        <Route path="/partner/whitelabel" element={<PartnerWhitelabelSettings />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'partner', 'sales_demo']} />}>
                        <Route path="/company" element={<CompanyContainer />} />
                        <Route path="/company/edit" element={<CompanyEditContainerTabs />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service']} />}>
                        <Route path="/partner" element={<PartnerContainer />} />
                        <Route path="/partner/edit" element={<PartnerEditContainer />} />
                        <Route path="/partner/add" element={<PartnerAddContainer />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'fleet_manager', 'group_manager', 'partner', 'user', 'partner_view', 'sales_demo', 'storage_manager', 'storage_user', 'custom_user', 'custom_partner']} />}>
                        <Route path="/event" element={<Events />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'fleet_manager', 'group_manager', 'partner', 'user', 'partner_view', 'sales_demo', 'storage_manager', 'storage_user', 'custom_user', 'custom_partner']} />}>
                        <Route path="/account" element={<AccountUserContainer />} />
                        <Route path="reports" element={<Reports />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'partner', 'partner_view']} />}>
                        <Route path="/fleet-admin/firmware" element={<Firmware />} />
                    </Route>
                    <Route element={<RequireRole roles={['system_admin', 'customer_service', 'fleet_manager', 'fleet_maintainer', 'partner', 'partner_view', 'sales_demo', 'custom_user', 'custom_partner']} />}>
                        <Route path="managedrivers" element={<ManageDriversPage />} />
                    </Route>
                    <Route path="/patterns/event/:device_id/:timestamp" element={<PatternsEventContainer />} />
                    <Route path="/patterns/events/:event_id/:event_type" element={<PatternsEventIdContainer />} />
                    <Route path="/patterns/drivers/:driver_trip_id" element={<PatternsDriverIdContainer />} />
                    <Route path="/patterns/device/installed/report/:report_id" element={<PatternsDeviceInstalledReport />} />
                    <Route path="/patterns/:type/device/:device_id/:timestamp" element={<PatternsDeviceContainer />} />
                    <Route path="/patterns/:type/device/:device_id" element={<PatternsDeviceContainer />} />
                </Route>
            </Route>
        </Routes>
    )
}

export default AppRoutes;
